import React from "react";
import { NavLink } from "react-router-dom";
import { TimestampToDateMoment } from "../../../utils/timestampToDate";
import { Alert } from "@material-ui/lab";
import PageSpinner from "../../elements/spinner/PageSpinner";
import { useTranslation } from "react-i18next";

import {
  StyledCol,
  StyledScrollTable,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTableRow
} from "../../styles/styledTable";
import { StyledProjectsWrapper } from "../styledProjects";

const ProjectList = ({ projects }) => {
  const { t } = useTranslation("projectsPage");

  if (!projects) {
    return <PageSpinner position="center" pt="20" pb="20"/>;
  }

  if (projects.length === 0) {
    return <Alert severity="warning">{t("table.emptyData")}</Alert>
  }

  return (
    <StyledProjectsWrapper>
      <StyledScrollTable>
        <StyledTable
          width="576"
          size="14"
          className="projects-table"
        >
          <StyledTableHead
            scroll="auto"
            col="3"
            className="projects-table__head"
          >
            <div>
              {t("table.name")}
            </div>
            <div className="projects-table__create-date">
              {t("table.createdAt")}
            </div>
          </StyledTableHead>
          <StyledTableBody>
            {projects && projects.map((value, key) => (
              <StyledTableRow
                key={key}
                scroll="auto"
                col="3"
                className="projects-table__row"
              >
                <StyledCol className="projects-table__project-name">
                  <NavLink to={`/projects/${value.id}`}>
                    {value.name}
                  </NavLink>
                </StyledCol>
                <StyledCol className="projects-table__create-date">
                  {TimestampToDateMoment(value.createDate)}
                </StyledCol>
              </StyledTableRow>
            ))}
          </StyledTableBody>
        </StyledTable>
      </StyledScrollTable>
    </StyledProjectsWrapper>
  );
};

export default ProjectList;